// extracted by mini-css-extract-plugin
export default {"block":"BlackCardWithIcon_block__HsPZe","icon":"BlackCardWithIcon_icon__VRQKQ","text":"BlackCardWithIcon_text__vpGxM"};